import { render, staticRenderFns } from "./InformationAssetWidgetComponent.vue?vue&type=template&id=569209d6&scoped=true&"
import script from "./InformationAssetWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./InformationAssetWidgetComponent.vue?vue&type=script&lang=js&"
import style0 from "./InformationAssetWidgetComponent.vue?vue&type=style&index=0&id=569209d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569209d6",
  null
  
)

export default component.exports